import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertFeed = ({ alerts }) => {
  const getSeverityStyles = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-error/10 border-error text-error';
      case 'high':
        return 'bg-warning/10 border-warning text-warning';
      case 'medium':
        return 'bg-accent/10 border-accent text-accent';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertTriangle';
      case 'high':
        return 'AlertCircle';
      case 'medium':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const alertTime = new Date(timestamp);
    const diffMs = now - alertTime;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 elevation-sm h-full">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Real-Time Alerts
        </h2>
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-error/10">
          <span className="text-xs font-semibold text-error">{alerts?.length}</span>
        </div>
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {alerts?.map((alert) => (
          <div 
            key={alert?.id}
            className={`p-3 md:p-4 rounded-lg border transition-smooth hover:elevation-sm ${getSeverityStyles(alert?.severity)}`}
          >
            <div className="flex items-start gap-3">
              <Icon name={getSeverityIcon(alert?.severity)} size={20} />
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-caption font-medium mb-1 line-clamp-2">
                  {alert?.message}
                </p>
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <span className="text-xs font-caption opacity-80">
                    {alert?.department}
                  </span>
                  <span className="text-xs font-caption opacity-80 whitespace-nowrap">
                    {formatTimestamp(alert?.timestamp)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertFeed;